import { useAuthStore } from '../../store/useAuthStore';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from '../shared/Loader';

interface AuthGuardProps {
  children: React.ReactNode;
  allowAppAccess?: boolean;
}

export const AuthGuard = ({ children, allowAppAccess }: AuthGuardProps) => {
  const { user, loading, initialized } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (!user && !loading && initialized && !redirectedRef.current) {
      redirectedRef.current = true;
      const returnUrl = location.pathname + location.search;
      navigate(allowAppAccess ? `/login?returnUrl=${encodeURIComponent(returnUrl)}` : '/');
    } else if (user) {
      redirectedRef.current = false;
    }
  }, [allowAppAccess, user, loading, initialized, location.pathname, location.search, navigate]);

  // Handle loading state
  if (loading && !initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  if (!user && !loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  return <>{children}</>;
};
